'use strict';

import { BaseController } from '../../base/controller';

export class DownloadController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({controllerService});
  }
}